import { UserTypeConstants } from '../../shared/user-type-constants';
var UserUtil = /** @class */ (function () {
    function UserUtil() {
    }
    UserUtil.isDwnCustomer = function (userType) {
        return userType === UserTypeConstants.DWN_USER;
    };
    UserUtil.isSohoCustomer = function (userType) {
        return userType === UserTypeConstants.BUSINESS_USER;
    };
    return UserUtil;
}());
export { UserUtil };
